import { State } from '../context';

export const getProposalRequest = (state: State) => state.proposalRequest;
